
/**
* src/connects/dashboard-user-page.js
*/

import { connect } from 'react-redux'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { validate } from '../helpers/form-validator'
import actions from '../actions'
import { translate } from 'react-i18next'
import moment from 'moment'
import config from '../config'
import ui from '../helpers/ui-state'
import filter from 'lodash/filter'
import map from 'lodash/map'

export function calcDetailsData(actions) {
  actions = map(actions, (action)=> ({
    x: moment(action.date).date(),
    y: moment.duration(action.time).as('hours'),
    time: action.time,
    type: action.type,
    reported_at: action.reported_at,
    reported_diff: action.reported_at && moment.duration(moment(action.date).diff(moment(action.reported_at))).as('days') || undefined
  }))
  return {
    diary:  filter(actions, (action)=> action.type == 'post-diary'),
    kpi:    filter(actions, (action)=> action.type == 'post-kpi'),
    memo:   filter(actions, (action)=> action.type == 'post-memo'),
    like:   filter(actions, (action)=> action.type == 'reply-like'),
    comment: filter(actions, (action)=> action.type == 'reply-comment'),
  }
}

export const mapStateToProps = (state, ownProps)=> {
  return {
    isFetching: state.dashboard.isDetailsFetching,
    user: state.dashboard.details && state.dashboard.details.user || ownProps.user,
    actions: state.dashboard.details && state.dashboard.details.actions,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    willMount: (props)=> {
      const endDate = props.ui.startDate.clone().endOf('month')
      dispatch(actions.fetchDashboardDetails(props.group.group_id, props.user.user_id, props.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    willUpdate:  (props, nextProps)=> {
      if (props.ui.startDate != nextProps.ui.startDate || props.user_id != nextProps.user_id) {
        const endDate = nextProps.ui.startDate.clone().endOf('month')
        dispatch(actions.fetchDashboardDetails(nextProps.group.group_id, nextProps.user.user_id, nextProps.ui.startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
      }
    },

    nextMonth: (props)=> {
      const startDate = props.ui.startDate.clone().add(1, 'months')
      const endDate = startDate.clone().endOf('month')
      props.updateUI({ startDate })
      dispatch(actions.fetchDashboardDetails(props.group.group_id, props.user.user_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    prevMonth: (props)=> {
      const startDate = props.ui.startDate.clone().add(-1, 'months')
      const endDate = startDate.clone().endOf('month')
      props.updateUI({ startDate })
      dispatch(actions.fetchDashboardDetails(props.group.group_id, props.user.user_id, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')))
    },

    willUnmount: ()=> dispatch(actions.clearDashboardDetails())
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({ state: { 
    startDate: (props)=> props.startDate || moment().startOf('month'),
  }}),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/dashboard-user-page.js